import { isProductionEnvironment, isUserInternalTest } from './helpers';
import { CaptureOptions } from 'posthog-js';
import { EventPayload } from 'interfaces';
import postHog from 'services/posthog';
import { store } from 'store';
import * as Sentry from '@sentry/react';

export const captureEvents = (
  event: string,
  userEmail: string,
  data?: EventPayload,
  options?: CaptureOptions
) => {
  const user_id = store?.getState()?.user?.details?.id;
  if (user_id && !isUserInternalTest(userEmail)) {
    postHogCapture(event, userEmail, user_id, data, options);
    sendClarityEvent(event, user_id, data);
  }
};

const postHogCapture = (
  event: string,
  userEmail: string,
  user_id: string,
  data?: EventPayload,
  options?: CaptureOptions
) => {
  if (isProductionEnvironment && !isUserInternalTest(userEmail)) {
    postHog.capture(
      event,
      {
        ...data,
        IDs: user_id,
        distinct_id: user_id
      },
      options
    );
    sendClarityEvent(event, user_id, data);
  }
};

const sendClarityEvent = (
  event: string,
  user_id: string,
  data?: EventPayload
) => {
  if (isProductionEnvironment && window.clarity) {
    window.clarity('identify', user_id);
    window.clarity('event', event);
    data &&
      window.clarity(
        'set',
        event,
        JSON.stringify({
          ...data
        })
      );
  } else {
    console.warn('Clarity is not initialized');
  }
};

export const captureSentrySyntheticException = (
  message: string,
  tags?: { pathname: string; action: string },
  extra?: Record<string, string>
) => {
  isProductionEnvironment &&
    Sentry.captureException(new Error(message), { tags, extra });
};
